export const ATTRIBUTE_CONSTS = {
    GET_ATTRIBUTES: "GET_ATTRIBUTES",
    GET_ATTRIBUTE_BY_ID: "GET_ATTRIBUTE_BY_ID",
    CREATE_ATTRIBUTE: "CREATE_ATTRIBUTE",
    UPDATE_ATTRIBUTE_BY_ID: "UPDATE_ATTRIBUTE_BY_ID",
    DELETE_ATTRIBUTE_BY_ID: "DELETE_ATTRIBUTE_BY_ID",
};
